import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastService } from './services/toast.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private toastService: ToastService,
    private translate: TranslateService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error) => {
        let errorMessage: string = '';

        if (
          error?.status == 400 ||
          error?.status == 404 ||
          error?.status == 500
        ) {
          errorMessage = error?.error?.detail;
        } else if (error?.status == 401) {
          errorMessage = this.translate.instant('error.unauthorized');
        } else if (error?.status == 403) {
          errorMessage = this.translate.instant('error.forbidden');
        } else {
          errorMessage = this.translate.instant('error.errorOccured');
        }
        this.toastService.showToast(errorMessage, 'error');
        return throwError(() => error);
      })
    );
  }
}
